import { Container, Graphics, Sprite } from "@pixi/react";
import { useEffect, useRef, useState } from 'react';
import { gameModuleService } from '../../services/gameModuleService';
import { Texture } from 'pixi.js';
import WinLine from '../winLine';
import { gameConfigurationStore } from '../../store/gameConfigurationStore';

export const ReelContainer = () => {
  const reelContainerRef = useRef();
  const winContainerRef = useRef();
  const touchSpinScreenRef = useRef();
  const { symbolsSizes, reelsContainerParams } = gameConfigurationStore;

  const [mask, setMask] = useState(null);
  const reelContainerConfig = {
    x: reelsContainerParams.xInFigma + symbolsSizes.width / 2,
    y: reelsContainerParams.yInFigma + symbolsSizes.height / 2,
    width: reelsContainerParams.width,
    height: reelsContainerParams.height,
  };
  const winContainerConfig = {
    x: reelsContainerParams.xInFigma + symbolsSizes.width / 2,
    y: reelsContainerParams.yInFigma + symbolsSizes.height / 2 + reelsContainerParams.emptySpaceForY * 2,
    width: reelsContainerParams.width,
    height: reelsContainerParams.height,
  };
  const touchSpinScreenConfig = {
    x: reelsContainerParams.xInFigma,
    y: reelsContainerParams.yInFigma,
    width: reelsContainerParams.width,
    height: reelsContainerParams.height,
  };
  useEffect(() => {
    if (reelContainerRef.current) {
      reelContainerRef.current.mask = mask;
    }
  }, [mask, reelContainerRef]);
  useEffect(() => {
    gameModuleService.createReels(
      reelContainerRef.current,
      winContainerRef.current,
      touchSpinScreenRef.current,
    );
    }, []);

  return (
    <>
      <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
        <Graphics
          draw={(g) => {
            g.beginFill(0xff700b);
            g.drawRect(
              -symbolsSizes.width / 2 +
                reelsContainerParams.offsetForContainerBoardWidth +
                reelsContainerParams.emptySpaceForX,
              -symbolsSizes.height / 2 +
                reelsContainerParams.offsetForContainerBoardHeight +
                reelsContainerParams.emptySpaceForY,
              reelsContainerParams.width -
                reelsContainerParams.offsetForContainerBoardWidth +
                2 * reelsContainerParams.emptySpaceForX,
              reelsContainerParams.height -
                reelsContainerParams.offsetForContainerBoardHeight +
                2 * reelsContainerParams.emptySpaceForY
            );
          }}
          ref={(graphicsRef) => setMask(graphicsRef)}
        />
      </Container>
      <Container ref={winContainerRef} {...winContainerConfig} name='WinContainer' />
      <WinLine />
      <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
        <Sprite
          texture={Texture.EMPTY}
          width={reelContainerConfig.width}
          height={reelContainerConfig.height}
        />
      </Container>
    </>
  );
};
